import React, { useEffect, useRef, useState } from 'react';
import spotifyScreenshot from '@/assets/spotify-screenshot.png';

export function SpotifyPhoneMockup() {
  const mockupRef = useRef<HTMLDivElement>(null);
  const [parallaxY, setParallaxY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!mockupRef.current) return;

      const rect = mockupRef.current.getBoundingClientRect();
      const centerY = window.innerHeight / 2;
      const elementCenter = rect.top + rect.height / 2;
      const distance = centerY - elementCenter;
      
      // Parallax effect: 20-30px range
      const parallax = (distance / window.innerHeight) * 25;
      setParallaxY(parallax);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial calculation

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div 
      ref={mockupRef}
      className="relative w-full max-w-[320px] lg:max-w-[370px] mx-auto lg:mx-0"
      style={{ 
        transform: `translateY(${parallaxY}px)`,
        transition: 'transform 0.1s ease-out',
        willChange: 'transform'
      }}
    >
      {/* iPhone Frame */}
      <div 
        className="relative bg-white rounded-[3rem] p-3 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.2)] lg:shadow-[0_40px_80px_-20px_rgba(0,0,0,0.5)]"
        style={{
          transform: 'scale(1.02)',
        }}
      >
        {/* Notch */}
        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-24 h-6 bg-white rounded-b-3xl z-10" />
        
        {/* Screen */}
        <div className="relative bg-white rounded-[2.5rem] overflow-hidden aspect-[9/19.5]">
          <img 
            src={spotifyScreenshot} 
            alt="Spotify for Artists dashboard showing streaming analytics"
            className="w-full h-full object-cover"
            loading="lazy"
            decoding="async"
            width="370"
            height="800"
          />
        </div>
      </div>
    </div>
  );
}
